export const toRole = (role: string): PlatformRole => {
    switch (role) {
        case 'GlobalAdmin': return 'GlobalAdmin'
        case 'SubMember':
        case 'Member': return 'Member'
        case 'Seller': return 'Seller'
        default: throw new Error(`Unknown platform role: ${role}`)
    }
}

export type PlatformRole = 'GlobalAdmin' | 'Member' | 'Seller'